var slidebarss = require('./vendorslidebars.js');


( function ( $ ) {

        console.log('ok');
        var controller = new slidebarss();
        controller.init();
        console.log('ok');

        $( '.MobileNavOpen' ).on( 'click', function ( event ) {
          // Stop default action and bubbling
          event.stopPropagation();
          event.preventDefault();

           console.log('clicked');

          // Toggle the Slidebar with id 'mobileMenu'

         controller.open( 'mobileMenu' );
        } );

        $( '.MobileNavClose' ).on( 'click', function ( event ) {
          // Stop default action and bubbling
          event.stopPropagation();
          event.preventDefault();

           console.log('clicked');

          // Toggle the Slidebar with id 'mobileMenu'
          controller.close( 'mobileMenu' );
        } );



} ) ( jQuery );
